import { ArrowUp, ArrowDown, ArrowLeft, ArrowRight, RotateCcw } from "lucide-react";

const LIMIT = 0.25;
const clamp = (v) => Math.max(-LIMIT, Math.min(LIMIT, Math.round(v * 100) / 100));
const KEY = (t) => `velopaths_label_offset_${t}`;

export const loadOffset = (template) => {
  try { const o = JSON.parse(localStorage.getItem(KEY(template)) || "{}"); return { x: clamp(+o.x || 0), y: clamp(+o.y || 0) }; }
  catch { return { x: 0, y: 0 }; }
};
export const saveOffset = (template, o) => localStorage.setItem(KEY(template), JSON.stringify(o));

const Nudge = ({ onClick, icon: Icon, label, testid }) => (
  <button type="button" onClick={onClick} title={label} aria-label={label} data-testid={testid}
    className="w-8 h-8 rounded-lg border border-border flex items-center justify-center hover:border-primary hover:text-primary active:scale-95 transition-[color,border-color,transform] duration-150">
    <Icon className="w-4 h-4" />
  </button>
);

const describe = (v, pos, neg) => (v === 0 ? "centred" : `${Math.abs(v).toFixed(2)}" ${v > 0 ? pos : neg}`);

export const PrinterFineTune = ({ value, onChange }) => {
  const set = (x, y) => onChange({ x: clamp(x), y: clamp(y) });
  const step = 0.01;
  return (
    <div className="flex items-center gap-4" data-testid="labels-fine-tune">
      <div className="grid grid-cols-3 gap-1 w-fit">
        <span /><Nudge icon={ArrowUp} label="Move up 0.01 inch" onClick={() => set(value.x, value.y - step)} testid="labels-nudge-up" /><span />
        <Nudge icon={ArrowLeft} label="Move left 0.01 inch" onClick={() => set(value.x - step, value.y)} testid="labels-nudge-left" />
        <Nudge icon={RotateCcw} label="Reset" onClick={() => set(0, 0)} testid="labels-nudge-reset" />
        <Nudge icon={ArrowRight} label="Move right 0.01 inch" onClick={() => set(value.x + step, value.y)} testid="labels-nudge-right" />
        <span /><Nudge icon={ArrowDown} label="Move down 0.01 inch" onClick={() => set(value.x, value.y + step)} testid="labels-nudge-down" /><span />
      </div>
      <div className="text-xs space-y-1 tabular-nums" data-testid="labels-offset-summary">
        <div><span className="text-muted-foreground">Left / right:</span> <b>{describe(value.x, "right", "left")}</b></div>
        <div><span className="text-muted-foreground">Up / down:</span> <b>{describe(value.y, "down", "up")}</b></div>
        <div className="text-muted-foreground">Each click = 0.01". Max 0.25". Saved for this template on this device.</div>
      </div>
    </div>
  );
};
